'use client'

import { twMerge } from '@/lib/classname/twMerge'
import { useTranslation } from '@/lib/i18n/useTranslation.client'

type QuantityPickerReadOnlyProps = Pick<
  UiComponentProps<{ value: number }>,
  'value' | 'className' | 'id' | 'data-testid' | 'aria-label'
>

export function QuantityPickerReadOnly({
  value,
  className,
  id,
  'data-testid': dataTestId,
  'aria-label': ariaLabel,
}: QuantityPickerReadOnlyProps) {
  const { t } = useTranslation(['QuantityPicker'])

  return (
    <p
      id={id}
      aria-label={ariaLabel ?? t('QuantityPicker:readOnlyAriaLabel', { value })}
      data-testid={dataTestId ?? 'quantity-picker-read-only'}
      className={twMerge(
        className,
        'w-max shrink-0 rounded-sm border-px border-solid border-brand-2-200 bg-brand-2-50 px-2 py-1 text-md font-bold leading-light text-brand-2-900 hd:border-1.5',
      )}
    >
      {t('QuantityPicker:readOnlyLabel', { value })}
    </p>
  )
}
